<template>
  <div v-if="logisticEnable" class="delivery-data">
    <unit-title title="物流信息" />
    <div class="row">
      <div class="label">
        快递名称:
      </div>
      <div class="value">
        {{ getExpressName(logisticCompany) }}
      </div>
    </div>
    <div class="row">
      <div class="label">
        快递单号:
      </div>
      <div class="value">
        {{ logisticCode }}
      </div>
    </div>
    <div class="logistics-information">
      <van-steps v-if="TracesData.Success" direction="vertical" :active="0">
        <van-step v-for="({ AcceptStation, AcceptTime }) of TracesData.Traces" :key="AcceptTime">
          <h4>{{ AcceptStation }}</h4>
          <p>{{ AcceptTime }}</p>
        </van-step>
        <div v-if="!TracesData.Traces.length" class="tips">
          {{ TracesData.Reason }}
        </div>
      </van-steps>
    </div>
  </div>
</template>

<script>
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
import api from '@/api'
import { EXPRESS_OPTIONS } from '@/constant/common'
export default {
  name: 'DeliveryData',
  components: { UnitTitle },
  props: {
    logisticCompany: {
      type: String,
      default: ''
    },
    logisticCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      TracesData: {
        Success: false,
        Traces: []
      }
    }
  },
  computed: {
    logisticEnable() {
      return this.logisticCompany && this.logisticCode
    }
  },
  watch: {
    logisticCode: {
      handler() {
        if (this.logisticEnable) {
          this.getTraceExpress(this.logisticCompany, this.logisticCode)
        }
      },
      immediate: true
    }
  },
  methods: {
    getTraceExpress(logisticCompany, logisticCode) {
      api.getTraceExpress({
        logisticCompany,
        logisticCode
      }).then(({ data }) => {
        data.Traces = data.Traces ? data.Traces.reverse() : []
        this.TracesData = data
      })
    },
    getExpressName(code) {
      const item = EXPRESS_OPTIONS.find(item => item.value === code) || {}
      return item.label || ''
    }
  }
}
</script>

<style lang='less' scoped>
.delivery-data {
  padding-top: 20px;
}
.row {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 1;
  margin-top: 10px;
  .label {
    word-break: keep-all;
    margin-right: 10px;
    font-weight: bold;
  }
}
.logistics-information {
  margin-top: 12px;
  border-radius: 10px;
  padding: 4px;
  font-size: 14px;
  .tips {
    color: #828282;
    font-size: 14px;
  }
}
</style>
